const NOTIFICATION_HUB_TAGS = {
  SUBSCRIBERS: "SUBSCRIBERS"
};
const NOTIFICATION_HUB_URL_SEGMENTS = {
  NOTIFICATION_SUBSCRIPTIONS: "notification-subscriptions"
};
const apiVersion = "2023-09-30-preview";
export {
  NOTIFICATION_HUB_TAGS,
  NOTIFICATION_HUB_URL_SEGMENTS,
  apiVersion
};
//# sourceMappingURL=common.js.map
